import { MessageSquare, ClipboardList, Settings } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import './IconRail.css';

export type SidebarTab = 'chat' | 'work' | 'admin';

interface IconRailProps {
    activeTab: SidebarTab;
    onTabChange: (tab: SidebarTab) => void;
}

export default function IconRail({ activeTab, onTabChange }: IconRailProps) {
    const { isAdmin, hasModuleAccess, tickets, currentUser, unreadCounts } = useApp();
    // Show admin tab only if user has admin permission AND module access
    const canAccessAdmin = isAdmin && hasModuleAccess('admin');

    // Count unread assigned tickets
    const unreadAssignedTickets = tickets?.filter(t => {
        const isAssigned = t.assignees?.some((a: any) => a.id === currentUser?.id);
        const hasUnread = (unreadCounts?.ticket?.[t.id] || 0) > 0;
        return isAssigned && hasUnread;
    }).length || 0;

    // Count unread chat messages
    const unreadChatMessages =
        Object.values(unreadCounts?.channel || {}).reduce((a, b) => a + (b as number), 0) +
        Object.values(unreadCounts?.dm || {}).reduce((a, b) => a + (b as number), 0);

    return (
        <div className="icon-rail">
            <div className="icon-rail-top">
                <button
                    className={`icon-rail-btn ${activeTab === 'chat' ? 'active' : ''}`}
                    onClick={() => onTabChange('chat')}
                    title="Chat"
                    style={{ position: 'relative' }}
                >
                    <MessageSquare size={22} strokeWidth={1.5} />
                    {activeTab !== 'chat' && unreadChatMessages > 0 && (
                        <div style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            background: 'var(--color-danger)',
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 'bold',
                            padding: '1px 5px',
                            borderRadius: 10,
                            border: '2px solid var(--sidebar-bg)',
                            lineHeight: 1
                        }}>
                            {unreadChatMessages}
                        </div>
                    )}
                </button>
                <button
                    className={`icon-rail-btn ${activeTab === 'work' ? 'active' : ''}`}
                    onClick={() => onTabChange('work')}
                    title="Work"
                    style={{ position: 'relative' }}
                >
                    <ClipboardList size={22} strokeWidth={1.5} />
                    {unreadAssignedTickets > 0 && (
                        <div style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            background: 'var(--color-danger)',
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 'bold',
                            padding: '1px 5px',
                            borderRadius: 10,
                            border: '2px solid var(--sidebar-bg)',
                            lineHeight: 1
                        }}>
                            {unreadAssignedTickets}
                        </div>
                    )}
                </button>
                {canAccessAdmin && (
                    <button
                        className={`icon-rail-btn ${activeTab === 'admin' ? 'active' : ''}`}
                        onClick={() => onTabChange('admin')}
                        title="Admin"
                    >
                        <Settings size={22} strokeWidth={1.5} />
                    </button>
                )}
            </div>
        </div>
    );
}
